module.exports = __webpack_public_path__ + "img/h_s2e2_interactions_1.e7d2050d.png";